import React, { useState } from 'react';

import { Table } from 'components/Table';
import { useTable } from './hooks';

import { Container, TableWrapper } from './JobHistoryStyles';
import { Footer } from '../ManageJobsStyles';
import { Button, SearchInput } from 'components';
import { Controls } from '../ScheduledJobs/ScheduledJobsStyles';
import { ControlsSearch } from 'components/TableTabbed/TableTabbedStyles';
import { DEFAULT_TABLE_SEARCH_NO_DATA_MESSAGE } from 'components/Table/contants';

type Props = {
  onClose: () => void;
};

export const JobHistory: React.FC<Props> = ({ onClose }) => {
  const [searchInput, setSearchInput] = useState('');
  const { table, isLoading } = useTable({ searchInput });

  return (
    <Container>
      <Controls>
        <ControlsSearch>
          <SearchInput
            placeholder='Search'
            onInput={(value) => setSearchInput(value.toLowerCase())}
          />
        </ControlsSearch>
      </Controls>
      <TableWrapper>
        <Table
          data={table.data}
          columns={table.columns}
          pagination
          selector='.modal.show'
          isLoading={isLoading}
          noResultsMessage={
            !isLoading ? DEFAULT_TABLE_SEARCH_NO_DATA_MESSAGE : ''
          }
        />
      </TableWrapper>
      <Footer>
        <Button onClick={onClose} variant='secondary' data-testid='back-button'>
          Back to Benchmarks
        </Button>
      </Footer>
    </Container>
  );
};
